import { Box, styled } from '@mui/joy';
import { CheckCircle, Warning } from '@phosphor-icons/react';

import { warningTypeColorMap } from 'core/constants';
import { WarningType } from 'core/enums';
import { Color } from 'theme/enums';

interface IWrapperProps {
  color?: Color;
}

const shouldForwardProp = (prop: string) => !['color'].includes(prop);

const IconWrapper = styled(Box, { shouldForwardProp })<IWrapperProps>(({ theme, color }) => ({
  display: 'flex',
  color: color === Color.WARNING ? theme.palette?.[color]?.[500] : theme.palette?.[color].softColor,
  fontSize: 16,
}));

interface IProps {
  type?: WarningType;
}

const getWarningIcon = (type: WarningType) => {
  switch (type) {
    case WarningType.VALIDATED:
      return <CheckCircle />;
    case WarningType.ERROR:
    default:
      return <Warning />;
  }
};

export const WarningValidationIcon = ({ type = WarningType.ERROR }: IProps) => {
  return <IconWrapper color={warningTypeColorMap[type]}>{getWarningIcon(type)}</IconWrapper>;
};
